// extracted by mini-css-extract-plugin
module.exports = {"form":"form__eVjcY"};